export const enum PhoneCode {
    USA = '+1',
}

export const enum CountryIso2 {
    USA = 'US',
    MALAYSIA = 'MY',
    TURKEY = 'TR'
}

export const enum Locale {
    EnUs = 'en-US'
}